<mat-toolbar color="accent">Integration Key Generated</mat-toolbar>

<mat-dialog-content class="!pb-0 !text-black">
  <div class="flex flex-col gap-4">
    <div>
      Your integration key has been generated. Copy it or download it to a file.
      This key will not be shown again.
    </div>
    <div class="flex flex-row items-center gap-2">
      <div
        class="flex grow items-center gap-2 break-all rounded bg-slate-100 px-4 py-2 font-mono text-sm"
      >
        <span class="flex grow">{{ data.integrationKey }}</span>
        <button
          class="icon-sm"
          mat-icon-button
          (click)="copy()"
          matTooltip="Copy to clipboard"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <button mat-flat-button color="primary" (click)="download()">
        <mat-icon>download</mat-icon>
        Download
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex grow"></div>
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
